export const save = (field, value) => {
  if (typeof window !== 'undefined') {
    const json = JSON.stringify(value)
    localStorage.setItem(field, json)
  }
}

export const remove = (field) => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(field)
  }
}

export const load = (field) => {
  try {
    if (typeof window !== 'undefined') {
      const json = localStorage.getItem(field)
      if (json) {
        return JSON.parse(json)
      }
    }
    return null
  } catch (err) {
    console.error("There was an issue loading the local storage", err)
    return null
  }
}

export const saveSession = (field, value) => {
  if (typeof window !== "undefined") {
    const json = JSON.stringify(value)
    sessionStorage.setItem(field, json)
  }
}

export const loadSession = (field) => {
  try {
    if (typeof window !== "undefined") {
      const json = sessionStorage.getItem(field)
      if (json) {
        return JSON.parse(json)
      }
    }
    return null
  } catch (err) {
    console.error("There was an issue loading the session storage", err)
    return null
  }
}
